/**
 * Routes of the MRI subscription funnel, defined once for every consumer
 * (step configs, step-route mapping tables, imperative navigations).
 */

/** Base routes without the trailing risk id (createStepConfig appends `/${riskId}` itself). */
export const MRI_ROUTES = {
  registration: "/simulation/inscription/mri",
  copropertyRegistration: "/simulation/inscription/mri/copropriete",
  copropertySurvey: "/simulation/inscription/mri/questionnaire",
  copropertyBuildings: "/simulation/inscription/mri/batiments",
  copropertyComplements: "/simulation/inscription/mri/complements",
  copropertyClaims: "/simulation/inscription/mri/sinistralite",
  eligibilitySummary: "/simulation/inscription/mri/synthese",
  // Tarificateur générique (PricingProcess), piloté par l'id du risque : pas de route MRI dédiée.
  pricing: "/simulation/tarification",
} as const;

/** Same routes as templates with the `:riskId` param, for the step-route mapping tables. */
export const MRI_ROUTE_TEMPLATES = {
  registration: `${MRI_ROUTES.registration}/:riskId`,
  copropertyRegistration: `${MRI_ROUTES.copropertyRegistration}/:riskId`,
  copropertySurvey: `${MRI_ROUTES.copropertySurvey}/:riskId`,
  copropertyBuildings: `${MRI_ROUTES.copropertyBuildings}/:riskId`,
  copropertyComplements: `${MRI_ROUTES.copropertyComplements}/:riskId`,
  copropertyClaims: `${MRI_ROUTES.copropertyClaims}/:riskId`,
  eligibilitySummary: `${MRI_ROUTES.eligibilitySummary}/:riskId`,
  pricing: `${MRI_ROUTES.pricing}/:riskId`,
} as const;

/** Labels of the MRI steps in the step-route mapping tables. */
export const MRI_ROUTE_LABELS = {
  registration: "Gérer le représentant",
  copropertyRegistration: "Gérer la copropriété",
  copropertySurvey: "Questionnaire copropriété",
  copropertyBuildings: "Bâtiments de la copropriété",
  copropertyComplements: "Compléments du dossier",
  copropertyClaims: "Sinistralité",
  eligibilitySummary: "Synthèse d'éligibilité",
  pricing: "Tarification",
} as const;
